import { SignRecupMethod } from '../sign/enums/sign-recup-method';

export class SignStockSetRecupMethodRequest {
  signId: number;
  recupMethod: SignRecupMethod;
}
